(function(){
    var paths = document.querySelectorAll('.svg-path');    
    paths.forEach((path) => {
        var length = (path as SVGPathElement).getTotalLength();
        path.setAttribute('stroke-dasharray', length.toString());
        path.setAttribute('stroke-dashoffset', '0');
        (path as SVGPathElement).style.setProperty('--offset-to', (length * 2).toString());
        (path as SVGPathElement).style.setProperty('--offset-from', length.toString());      
    })   
})()